import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { default as MuiHidden } from '@material-ui/core/Hidden';
/**
 * A component that toggles the visibility value of components.
 * @done false
 * @updated v3.14.0
 * @versionAdded v3.14.0
 * @lab true
 * @examples
 *  HiddenGrid
 */

var Hidden = function Hidden(props) {
  var rest = _extends({}, props);

  return /*#__PURE__*/React.createElement(MuiHidden, rest);
};

Hidden.muiName = 'Hidden';
Hidden.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Specify which implementation to use. 'js' is the default, 'css' works better for server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the js implementation with server-side rendering.
   *
   * As window.innerWidth is unavailable on the server, we default to rendering an empty component during the first mount. You might want to use an heuristic to approximate the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the [client-hints](https://caniuse.com/#search=client%20hint).
   */
  initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),

  /**
   * If true, screens this size and down will be hidden.
   *
   * To hide at all breakpoints, it's preferrable to use `xsUp` than `lgDown`. See usage notes for details.
   */
  lgDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s). Can be any valid breakpoint or an array of valid breakpoints.
   *
   * See usage notes for more information.
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
};
Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xsDown: false,
  xsUp: false
};
export default Hidden;